// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__srC22","letter":"styles_letter__u4nc5","triangle":"styles_triangle__xOXW3"};